import PropTypes from 'prop-types'
import React from 'react'
import { withRouter } from '@/checkout-instore-legacy/utils/withRouter'
import { clearExpiredCache } from '@/checkout-instore-legacy/cache/CacheCleaner'
import CookieHelper from '@/checkout-instore-legacy/utils/CookieHelper'

import LoginForm from './LoginForm'
import Loader from '@/checkout-instore-legacy/components/Commons/Loader'

class Login extends React.Component {
  componentDidMount() {
    this.props.loadInStoreVendor()
    this.checkLogin()
    clearExpiredCache()
  }

  componentDidUpdate() {
    this.checkLogin()
  }

  checkLogin() {
    const vtexIdToken = CookieHelper.getVtexIdToken()
    if (this.props.vendor && this.props.store && vtexIdToken) {
      setTimeout(() => {
        this.props.router.push('/')
      })
    }
  }

  render() {
    return (
      <div className="flex flex-column vh-100 flex-auto">
        <Loader loading={this.props.loading} />
        <LoginForm />
      </div>
    )
  }
}

Login.propTypes = {
  router: PropTypes.any,
  vendor: PropTypes.object,
  store: PropTypes.object,
  loading: PropTypes.bool,
  loadInStoreVendor: PropTypes.func.isRequired,
}

export default withRouter(Login)
